/**
 * @fileoverview GET handler for the "/:app_group_id/generative_ai/agents/canvas_qa" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsCanvasQa } from "./constants";
import type { GetGenerativeAiAgentsCanvasQaParams, GetGenerativeAiAgentsCanvasQaResult } from "./types";
import { isGetGenerativeAiAgentsCanvasQaResult } from "./validators";

export const getGenerativeAiAgentsCanvasQa = reactQueryFetcherAdapter(
  generativeAiAgentsCanvasQa,
  (
    signal: AbortSignal,
    { appGroupId, canvasTerritoryIds }: GetGenerativeAiAgentsCanvasQaParams
  ): Promise<GetGenerativeAiAgentsCanvasQaResult> => {
    const queryParams = new URLSearchParams();
    (canvasTerritoryIds ?? []).forEach((id) => queryParams.append("canvas_territory_ids[]", id));
    const queryString = queryParams.toString();
    const url = queryString
      ? `/${appGroupId}/generative_ai/agents/canvas_qa?${queryString}`
      : `/${appGroupId}/generative_ai/agents/canvas_qa`;
    return fetch(url, "GET", {}, { signal }, { propagateFetchRequestError: false });
  },
  isGetGenerativeAiAgentsCanvasQaResult
);
